import * as React from 'react';
import { DataGrid,  } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';




const paginationModel = { page: 0, pageSize: 5 };

export default function QueryTable({columnData,tableData}) {
  return (
    <Paper sx={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={tableData}
        columns={columnData}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
        autosizeOnMount
        sx={{ border: 0 }}
      />
    </Paper>
  );
}